var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"min-width":"320px","min-height":"100px"},attrs:{"id":"div-gpt-ad-1698392900247-0"}})])
}]

export { render, staticRenderFns }